import React from "react";
import { CarrierAgreementMgmtTabs } from "../../CarrierAgreementMgmt/carrierAgreementTabs";
import { VendorInvoiceTabs } from "../../CarrierAgreementMgmt/VendorInvoice/VendorInvoiceTabs";
import { EmployeeTabs } from "../../EmployeeTab/EmployeeTab";
import { OfficeTabs } from "../../OfficeTab/OfficeTabs";
import { ReportsTabs } from "../../ReportsTab/ReportsTab";
import { AgreementTabs } from "../../Utilities/ConfigureAgreement/UtilitiesAgreementTabs";
import { PolicyTermTabs } from "../../Utilities/PolicyTerms/UtilitiesPolicyTermTabs";
import { UtilitiesTabs } from "../../Utilities/utilitiesTabs";
import { VendorTabs } from "../../VendorTab/VendorTab";
import { OfficeTabs as UtilitiesOfficeTabs } from "../../Utilities/Office/UtilitiesOfficeTabs";
import { UserManagementTabs } from "../../Utilities/UserModuleandRoleMgt/UserManagementTabs";
import { EmailTabs } from "../../Utilities/EmailRecipientConfiguration/UtilityEmailTabs";
import { EmployeeTabs as UtilitiesEmployeeTabs } from "../../Utilities/EmployeeConfiguration/UtilityEmailTabs";
import { ProducerConfigurationTabs } from "../../Utilities/ProducerConfiguration/ProducerConfigurationTabs";
import { SecurityTabs } from "../../Utilities/SecurityConfiguration/UtilitySecurityTabs";
import { LeasedEquipmentTabs } from "../../Utilities/LeasedEquipmentConfiguration/UtilityLeasedEquipmentTabs";
import { OfficeAppliancesTabs } from "modules/Utilities/OfficeAppliances/OfficeAppliancesTabs";

export const UtilitiesTabNotif = (ModuleRoute: string) => {
  let tabs;
  const route = ModuleRoute?.toLowerCase();
  if (route?.includes("usersmanagement")) {
    tabs = UserManagementTabs;
  } else if (route?.includes("emailRecipientconfiguration")) {
    tabs = EmailTabs;
  } else if (route?.includes("configureagreement")) {
    tabs = AgreementTabs;
  } else if (route?.includes("policyterm")) {
    tabs = PolicyTermTabs;
  } else if (route?.includes("office")) {
    tabs = UtilitiesOfficeTabs;
  } else if (route?.includes("employeeconfiguration")) {
    tabs = UtilitiesEmployeeTabs;
  } else if (route?.includes("securityconfiguration")) {
    tabs = SecurityTabs;
  } else if (route?.includes("producerconfiguration")) {
    tabs = ProducerConfigurationTabs;
  } else if (route?.includes("leasedequipmentconfiguration")) {
    tabs = LeasedEquipmentTabs;
  } else if (route?.includes("appliancesconfiguration")) {
    tabs = OfficeAppliancesTabs;
  } else {
    tabs = UtilitiesTabs;
  }
  return tabs;
};

const ModuleTabs = (ModuleRoute: string) => {
  let result;
  const route = ModuleRoute?.toLowerCase();
  if (route?.includes("vendortab")) {
    result = VendorTabs;
  } else if (route?.includes("employeetab")) {
    result = EmployeeTabs;
  } else if (route?.includes("carrieragreementmgmt")) {
    result = CarrierAgreementMgmtTabs;
  } else if (route?.includes("officesettings")) {
    result = OfficeTabs;
  } else if (route?.includes("reportstab")) {
    result = ReportsTabs;
  } else if (route?.includes("utilitiestabs")) {
    result = UtilitiesTabs;
  }
  return result;
};

export default ModuleTabs;
